<script lang="ts">
  import Image from "$lib/atoms/Image.svelte";
  import { storyblokEditable } from "@storyblok/svelte";
  import StoryblokComponent from "$lib/StoryblokComponent.svelte";
  import type { ColumnStoryblok } from "$types/components";
  import { displayType } from "$lib/utils/breakpoints";

  export let blok: ColumnStoryblok;

  $: padding =
    $displayType === "desktop" && blok.desktopPadding
      ? blok.desktopPadding
      : blok.padding;
  $: margin =
    $displayType === "desktop" && blok.desktopMargin
      ? blok.desktopMargin
      : blok.margin;
  $: maxWidth =
    $displayType === "desktop" && blok.desktopMaxWidth
      ? blok.desktopMaxWidth
      : blok.maxWidth;

  $: blokContent = blok.content || [];
</script>

<div
  class={`
    flex-auto
    w-full
    flex
    flex-col
    ${blok?.className}
    ${blok?.horizontalAlignment}
    ${blok.background ? `bg-[rgb(var(${blok.background}))]` : ""}
		${blok.rounded ? "rounded-[var(--border-radius-wrapper)]" : ""}
	`}
  class:fill-space={blok.fillAvailableSpace}
  class:vertical-gap={blok.verticalGap ||
    ["small", "medium", "large"].includes(blok.gap ?? "")}
  class:vertical-gap-sm={blok.gap === "small"}
  class:vertical-gap-md={blok.gap === "medium"}
  class:vertical-gap-lg={blok.gap === "large"}
  style="padding:{padding};margin:{margin};"
  use:storyblokEditable={blok}
>
  {#each blokContent as content}
    <div
      class="flex-auto w-full {blok?.innerClassName || ''}"
      style="max-width:{maxWidth};"
    >
      {#if content.component === "image" && content.object}
        <Image
          blok={content}
          media={content.object}
          caption={content.caption?.[0]}
          isSVG={content.isSVG}
          lgSize="100"
          smSize="100"
        />
      {:else}
        <StoryblokComponent blok={content} />
      {/if}
    </div>
  {/each}
</div>

<style lang="postcss">
  .fill-space {
    width: 100%;
  }

  .vertical-gap {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .vertical-gap-sm {
    @apply gap-4;
  }

  .vertical-gap-md {
    @apply gap-8;
  }

  .vertical-gap-lg {
    @apply gap-12;
  }
</style>
